import styled from 'styled-components';

export const ShadowStyled = styled.div`
  height: 100vh;
  width: 100vw;
  /* width: 100%; */
  /* height: 100%; */
  overflow-y: hidden;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: black;
  opacity: 0.7;
  z-index: 4;
`;
